import {Button, Col, Row} from "react-bootstrap";
import React from "react";
import {useNavigate} from "react-router-dom";
import AppRoute from "../../utils/AppRoute";

const ErrorPayment = () => {

    const navigate = useNavigate();

        return (
            <>
                <Row>
                    <Col lg={6}>

                        <Row className={'mt-5 mb-2'}>
                            <Col xs={12}>
                                <h2 className={'fw-bold'}>Pagamento annullato</h2>
                                <p className={'mt-4 mb-5'}>Nessun pagamento è avvenuto, l’ordine è ancora in preparazione.</p>
                            </Col>
                            <Col xs={12}>
                                <Button variant={'primary'} className={'px-5 fw-bold'}
                                        onClick={() => navigate(AppRoute.CART)}>
                                    Torna al carrello
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>

            </>

        );
}

export default ErrorPayment;
